import React, { useMemo, useState } from 'react';
import DHeader from '../../pieces/DHeader';
import DText from '../../pieces/DText';
import DCode from '../../pieces/DCode';

export default function DataConnections() {

    return (
        <div>
            <DHeader>Data Connections</DHeader>
       
            <DText>
            While Edges define the flow of control, the flow of data needs to be addressed. Different Nodes have data dependencies on other Nodes. The Data Connectors explicitly address this requirement.
            
            </DText>

            <br />

            <DText style={{fontWeight:'bold'}}>The set_node_input() function</DText>

            <DText>
            For an input that has a predefined value (not dependent on other Node outputs), use the flow.set_node_input() function. The name of the input and output variables of the Actions are referenced in the format 'Node|Action|Socket' as shown in the examples below.
            </DText>

          
            
            <DCode>
                {`simple_flow.set_node_input("Model0|model0|input0", "Input 0")`}
            </DCode>

            <br />

            <DText style={{fontWeight:'bold'}}>The add_data_source() function</DText>

            <DText>
                Use the add_data_source function to specify which App State values are inputs to the Action.
            </DText>

            

            <DText>1) To Connect Workflow Inputs to the Action</DText>

            <DCode>
              {`simple_flow.add_data_source("Model0|model0|input0", "INPUTS|input0")`}
            </DCode>

            <DText>2) To Connect to Output of another Node</DText>

            {/* <DText>
            Inputs are also dependent on outputs of previous nodes. You can connect the sockets using flow.add_data_source(destination_socket, source_socket)
            </DText> */}

            <DCode>
               {`simple_flow.add_data_source("Model1|model1|input1", "Model0|model0|output0")`}
            </DCode>

        </div>
    )
}